import { useEffect, useState } from "react";
import { _SpareInventoried } from "../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../../theme/Component/BasicTable";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { SelectSpareInventoriedType } from "../SelectSpareInventoriedType";
import { BasicButton } from "../../../../theme/Component/BasicButton";

interface Props {
    idSelector?: number;
    label?: string;
    onChange?: any;
}

export const EditorSpareInventoried = ({ label, onChange, idSelector }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_SpareInventoried);
    const [render, setRender] = useState<string>("");
    const [type, setType] = useState<number>(null);
    const mItems = useModal("Inventario de Items", MODAL_md);

    useEffect(() => {
        if (idSelector) {

        } else {
            setBean({});
            onChange({});
            setRender("");
        }
    }, [idSelector])

    const head = [
        { title: 'ID', property: 'IDSpareInventoried', visible: true },
        { title: 'Codigo', property: 'CodeInventoried', visible: true },
        { title: 'Nombre', property: 'IDItemName', visible: true },
        { title: 'Ubicación', property: 'IDLocationName', visible: true },
        { title: 'Utilidades', property: 'ItemUtilities', visible: true },
        { title: 'Cantidad Disponible', property: 'TotalQuantity', visible: true },
    ]

    const getLista = () => {
        const props = {
            State: 1,
            IDSpareInventoriedType: type,
        }
        if (type) {

            instance.getSpareInventoriedCatalogPorPropiedades(props, null).then(
                (resp: any) => {
                    if (resp) {
                        setLista(resp)
                    }
                }
            ).catch(err => { toast.error(err) })
        } else {
            toast.error("Seleccione una categoria")
        }
    }

    const returnData = () => {
        if (bean.IDSpareInventoried) {
            onChange?.(bean);
            setRender(`${bean.CodeInventoried} - ${bean.IDItemName}`);
            mItems.close()
        } else {
            toast.error("Objeto no valido")
        }
    }

    return (
        <>
            <label>{label ? label : 'Objeto de Inventario'}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={render}
                onClick={() => { mItems.open() }}
            />

            <Modal modal={mItems.modal} updateModal={mItems.setModal} eventModal={() => { returnData() }} >
                <div className="row">
                    <div className="col-md-10">
                        <SelectSpareInventoriedType idSelector={type} onChange={(e) => { setType(e) }} label="Tipo de Objeto" />
                    </div>
                    <div className="col-md-2 mt-4">
                        <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
                    </div>
                </div>
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </Modal>
        </>
    )
}